export default {
  add: 'nxAuthTokenAdd',
  remove: 'nxAuthTokenRemove',
}
